
var map;
var marker = [];
var infoWindow = [];



// Initialize and add the map
function initMap() {

console.log("[initMap] start");

  // The location of MIEKO MINTZ STUDIO
  const uluru = { lat: 40.726177, lng: -74.005063 };
  // The map, centered at MIEKO MINTZ STUDIO
  const map = new google.maps.Map(document.getElementById("map"), {
    zoom: 3,
    //zoom: 16,
    fullscreenControl: false,
    center: new google.maps.LatLng(40.726177, -74.005063),
    styles: [{
            stylers: [
                {
                    hue: '#ffbb00' // 色相
                }, {
                    saturation: -50 // 彩度
                }, {
                    lightness: 20 // 明度
                }, {
                    gamma: 0.5 // ガンマ
                }
            ]
        }]
    });




//  const iconBase = "https://maps.google.com/mapfiles/kml/shapes/";
  const iconBase = "./images/map/";
  const icons = {
    mm: {
      name: "MIEKO MINTZ",
//      icon: iconBase + "map-mm.png",
		icon: {
			url: '//miekomintz.com/cdn/shop/t/250/assets/mmpage.images.map.mm.png?v=65959096140853731611789353558',
			scaledSize: new google.maps.Size(40, 48), //マーカーのサイズを縮小
			anchor: new google.maps.Point(20, 36) //マーカーの表示位置を25pxだけ上に
		}

    },
    mmak: {
      name: "Maison Mieko",
//      icon: iconBase + "map-mmak.png",
		icon: {
			url:  '//miekomintz.com/cdn/shop/t/250/assets/mmpage.images.map.mmak.png?v=152028429299100618001789353559',
			scaledSize: new google.maps.Size(40, 48), //マーカーのサイズを縮小
			anchor: new google.maps.Point(20, 36) //マーカーの表示位置を25pxだけ上に
		}

    },
    mm_mmak: {
      name: "MIEKO MINTZ & Maison Mieko",
//      icon: iconBase + "map-mm-mmak.png",
		icon: {
			url:  '//miekomintz.com/cdn/shop/t/250/assets/mmpage.images.map.mm-mmak.png?v=136653370894759936501789353558',
			scaledSize: new google.maps.Size(40, 48), //マーカーのサイズを縮小
			anchor: new google.maps.Point(20, 36) //マーカーの表示位置を25pxだけ上に
		}



    },
  };















/* legend */

  const legend = document.getElementById("legend");
  for (const key in icons) {
    const type = icons[key];
    const name = type.name;
    const icon = type.icon;
    const div = document.createElement("div");

    div.innerHTML = '<img src="' + icon.url + '" class="legend-icon"> ' + name;
    legend.appendChild(div);
  }

//  map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(legend);
  map.controls[google.maps.ControlPosition.RIGHT_TOP].push(legend);










 // マーカー毎の処理

 let data = new XMLHttpRequest();
// data.open("GET", "./gmap/retailers.txt", false);
 data.open("GET", "//miekomintz.com/cdn/shop/files/retailers.txt?v=2469664073772392571", false);
// data.open("GET", "https://cdn.shopify.com/s/files/1/0790/1714/8719/files/retailers.txt.txt?v=1688735768", false);



  
 data.send(null);


//    let lines = data.responseText.split('\r\n');
    let lines = data.responseText.split('\n');

console.log("[parseData] start");
console.log("[parseData] lines.length:" + lines.length);

//    for (var i = 0 ; i < lines.length ; i++){
    for (var i = 1 ; i < lines.length ; i++){
      var vals = lines[i].split("\t");

      var name = vals[0];
      var lat = vals[9];
      var lng = vals[10];
      var mm = vals[7];
      var mmak = vals[8];
      var url = vals[6];
      var address = vals[4].replace(/"/g, '')
      var tel = vals[5];

console.log("[parseData] name:" + name);
console.log("[parseData] lat:" + lat);
console.log("[parseData] lnt:" + lng);
console.log("[parseData] url:" + url);


// ブランド区分
var brandDiv = 'mm';

if(mm == '1' && mmak == '1'){
	brandDiv = 'mm_mmak';
}else if(mm == '1'){
	brandDiv = 'mm';
}else if(mmak == '1'){
	brandDiv = 'mmak';
}
console.log("[parseData] brandDiv:" + brandDiv);



      marker[i] = new google.maps.Marker({ // マーカーの追加
        position: new google.maps.LatLng(lat, lng), // マーカーを立てる位置を指定
        icon: icons[brandDiv].icon,
         map: map // マーカーを立てる地図を指定
       });


    /* url */
     let strUrlStart = (url) ? '<a href="' + url + '" target="_blank">' : "";
     let strUrlEnd = (url) ? '</a>' : "";

     infoWindow[i] = new google.maps.InfoWindow({ // 吹き出しの追加
         content: '<div class="map-info">' + strUrlStart + '<p class="title">' + name + '</p>' + strUrlEnd + '<p class="address">' + address + '</p><p class="tel">' + tel + '</p></div>' // 吹き出しに表示する内容
       });

     markerEvent(i); // マーカーにクリックイベントを追加




      console.log("[parseData] end");
    }
}

// マーカーにクリックイベントを追加
function markerEvent(i) {
    marker[i].addListener('click', function() { // マーカーをクリックしたとき
      infoWindow[i].open(map, marker[i]); // 吹き出しの表示
  });






function parseData(){
  GDownloadUrl("retailers.txt", function dispData(data, statusCode){
    var lines = data.split("¥n");

    console.log("[parseData] start");

    for (var i = 0 ; i < lines.length ; i++){
      var vals = lines[i].split(",");

      var name = vals[0];
      var lat = vals[9];
      var lng = vals[10];

      marker[i] = new google.maps.Marker({ // マーカーの追加
        position: new google.maps.LatLng(lat, lng), // マーカーを立てる位置を指定
        icon: icons["mm"].icon,
         map: map // マーカーを立てる地図を指定
       });



      //map.addOverlay(createMarker(lat, lng, name));
      console.log("[parseData] end");
    }
  });
}



console.log("[initMap] end");

}



window.initMap = initMap;















